import React from 'react';
import { Content } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { NewAnnouncementBanner } from '@procore-oss/backstage-plugin-announcements';
import { HomeBanner } from './HomeBanner';
import { homeCards } from './homeCards';
import { HomeCard } from './HomeCard';
import {
  useSearchBarStyles,
  HomePageContainer,
  StyledLogo,
  HomeTitle,
  HomeColumn,
  HomeCardsContainer,
} from './HomeStyles';
import { styled } from '@material-ui/core';

const AnnouncementWrapper = styled('div')({
  '& .MuiSnackbar-root': {
    top: 0,
    marginTop: 0,
    marginBottom: '8px',
  },
});

export const HomePage = () => {
  const classes = useSearchBarStyles();
  const { firstColumn, secondColumn } = homeCards;
  return (
    <Content>
      <AnnouncementWrapper>
        <NewAnnouncementBanner active />
      </AnnouncementWrapper>
      <HomePageContainer>
        <HomeBanner>
          <>
            <StyledLogo />
            <HomeTitle variant="h5">
              Unlock the power of shared knowledge and tools to accelerate your
              development lifecycle
            </HomeTitle>
            <HomePageSearchBar
              InputProps={{
                classes: {
                  root: classes.searchBarInput,
                },
              }}
              className={classes.searchBar}
              placeholder="Search..."
            />
          </>
        </HomeBanner>
        <HomeCardsContainer>
          <HomeColumn>
            {firstColumn.map(card => (
              <HomeCard
                key={card.title}
                title={card.title}
                description={card.description}
                icon={card.icon}
                href={card.href}
              />
            ))}
          </HomeColumn>
          <HomeColumn>
            {secondColumn.map(card => (
              <HomeCard
                key={card.title}
                title={card.title}
                links={card.links}
              />
            ))}
          </HomeColumn>
        </HomeCardsContainer>
      </HomePageContainer>
    </Content>
  );
};
